import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { getDefaultNetworkStatus } from '@utils';

import { menuFetchListReducer } from './actions';

import { IMenuStore } from './types';

export const getMenuInitialState = (): IMenuStore => ({
	menu: {
		data: {
			list: [],
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
});

export const menu = reducerWithInitialState<IMenuStore>(getMenuInitialState());

menuFetchListReducer(menu);
